import api from '@/api/index.js'

const municipalities = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_MUNICIPALITIES_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_MUNICIPALITIES: (state, data) => {
      state.data = data
      state.loading = false;
    },
    SET_MUNICIPALITIES_ERROR: (state, error) => {
      state.error = error
      state.loading = false;
    }
  },

  actions: {
    LoadMunicipalities({commit}, query) {
      var queryStr = "?limit=150&offset=0"
      if (query) {
        queryStr = queryStr + `&resident_pricing=${query.resident_pricing}`
      }

      commit('SET_MUNICIPALITIES_LOADING', true)
      return api.get(`municipalities${queryStr}`)
        .then((response) => {
          commit('SET_MUNICIPALITIES', response)
          commit('SET_MUNICIPALITIES_LOADING', false)
        })
        .catch((error) => {
          commit('SET_MUNICIPALITIES_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  }
}

export default municipalities
